import { render, staticRenderFns } from "./LawSearch.vue?vue&type=template&id=34dfc8fa&scoped=true"
import script from "./LawSearch.vue?vue&type=script&lang=js"
export * from "./LawSearch.vue?vue&type=script&lang=js"
import style0 from "./LawSearch.vue?vue&type=style&index=0&id=34dfc8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dfc8fa",
  null
  
)

export default component.exports